import { Dropdown } from "primereact/dropdown";
import { ReactComponent as Frame_bot } from "../../assets/Frame_bot.svg";
import { ReactComponent as WEB } from "../../assets/WEB.svg";

import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";

const ConfigureAI = ({ registrationForm, setRegistrationForm, disabled }) => {
  const [aiFeature, setAiFeature] = useState("");
  const [aiBotName, setAiBotName] = useState("");
  const [botTrigger, setBotTrigger] = useState(true);

  const handleOnChange = (e, field) => {
    if (field === "botTrigger") {
      setBotTrigger(e?.checked);
    } else if (field === "aiFeature") {
      setAiFeature(e.value);
    } else if (field === "aiBotName") {
      setAiBotName(e.target.value);
    }

    setRegistrationForm((prevState) => ({
      ...prevState,
      aiFeature: aiFeature,
      aiBotName: aiBotName,
      botTrigger: botTrigger,
    }));
  };
  useEffect(() => {
    setAiFeature(registrationForm?.aiFeature);
    setAiBotName(registrationForm?.aiBotName);
    setBotTrigger(registrationForm?.botTrigger);
  }, [registrationForm]);

  const featureOptions = [
    { label: "ALL", value: "ALL" },
    { label: "FAQ", value: "FAQ" },
    { label: "Conversation AI", value: "CONVERSATIONAL" },
  ];

  return (
    <div className="border border-red-500 rounded-md">
      <div className="pt-3">
        <span className="text-lg font-medium">
          <WEB className="mx-1 pt-1" />
          Customize the bot based on your company’s requirements
        </span>
      </div>
      <div className="flex justify-content-between align-items-start p-2">
        <div className="mb-3 mt-3 w-full pr-8">
          <div className="mb-4 mt-3">
            <label className="block mb-2 text-gray-900">AI Features</label>
            <Dropdown
              value={aiFeature}
              options={featureOptions}
              onChange={(e) => handleOnChange(e, "aiFeature")}
              className="w-full"
              placeholder="Select features"
              disabled={disabled}
            />
          </div>
          <div className="mb-4 mt-3 w-full">
            <label className="block mb-2 text-gray-900">AI Bot Name</label>
            <InputText
              value={aiBotName}
              onChange={(e) => handleOnChange(e, "aiBotName")}
              className="w-full"
              disabled={disabled}
            />
          </div>
          <div className="flex">
            <label className="block mb-2 text-gray-900 mr-2">
              AI Bot Trigger
            </label>
            <Checkbox
              checked={botTrigger}
              onChange={(e) => handleOnChange(e, "botTrigger")}
              className="mt-1"
              disabled={disabled}
            />
          </div>
        </div>
        <div>
          <div className="p-4 flex justify-center items-center">
            <Frame_bot />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigureAI;
